import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Segmented } from 'antd';
import { useAggregationConfig } from '../../../../hooks/SimViewer/useAggregationConfig';

const AreaAggregationConfig = (): ReactNode => {
  const { t } = useTranslation();
  const { aggregationConfig, changeAggregationMetric } = useAggregationConfig();

  return (
    <StyledSegmented
      options={[
        {
          value: 'count_per_area',
          label: t('countPerArea'),
          className: 'antd-segmented-item-grow',
          disabled: false,
        },
        {
          value: 'count',
          label: t('absoluteCount'),
          className: 'antd-segmented-item-grow',
          disabled: false,
        },
      ]}
      value={aggregationConfig?.metric}
      onChange={(value: string | number): void => {
        if (value === 'count_per_area' || value === 'count') {
          changeAggregationMetric(value);
        }
      }}
    />
  );
};

const StyledSegmented = styled(Segmented)`
  .ant-segmented-item:not(.antd-segmented-item-grow) {
    flex: 0 1 48px;
  }
  .ant-segmented-item.antd-segmented-item-grow {
    flex: 1 1 0px;
  }
  .ant-segmented-item-label {
    padding: 0 2px;
  }
`;

export { AreaAggregationConfig };
